<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>
    <div class="container-fluid mt--7">
      <card shadow>
        <div slot="header" class="border-0">
          <div class="row align-items-center">
            <div class="col-1">
              <base-button type="primary" size="sm" @click="$router.back()"
                ><i class="ni ni-bold-left mt-1"></i
              ></base-button>
            </div>
            <div class="col-8">
              <h3 class="mb-0">{{ $t("inventory_new") }}</h3>
            </div>
          </div>
        </div>
        <template>
          <div class="pl-lg-4">
            <div class="row justify-content-center">
              <div class="mb-3 col-md-12 col-lg-12">
                <b-button
                  class="ml-auto"
                  :disabled="warehouse_qty.length > 4 ? true : false"
                  @click="addFind"
                  variant="primary"
                  size="sm"
                  >{{ $t("add_inventory") }}</b-button
                >
                <b-button
                  class="ml-auto"
                  @click="$refs.create.showModal()"
                  variant="secondary"
                  size="sm"
                  >{{ $t("add_warehouses") }}</b-button
                >
              </div>
              <div class="mb-3 col-md-12 col-lg-12">
                <form @submit.prevent>
                  <div class="row">
                    <div
                      class="col-12 row"
                      v-for="(item, index) in warehouse_qty"
                      :key="index"
                    >
                      <div class="col-md-5">
                        <base-input :label="$t('warehouses')">
                          <v-select
                            label="name"
                            class="
                              form-control-alternative
                              border
                              bg-white
                              p-1
                              rounded
                              mb-2
                            "
                            v-model="item.warehouse_id"
                            :reduce="(name) => name.id"
                            :placeholder="$t('warehouses')"
                            autocomplete="ÑÖcompletes"
                            :options="warehouseData"
                            data-vv-validate-on="blur"
                            v-validate="'required|min:1'"
                            :data-vv-as="$t('warehouses')"
                            name="warehouses"
                          >
                            <template #no-options="{}">
                              {{ $t("fail") }}
                            </template>
                          </v-select>
                          <span
                            class="text-danger text-sm"
                            v-show="errors.has('inventory')"
                            ><small>{{ errors.first("inventory") }}</small></span
                          >
                        </base-input>
                      </div>
                      <div class="col-md-4">
                        <base-input
                          type="search"
                          :label="$t('quantity')"
                          :placeholder="$t('quantity')"
                          input-classes="form-control-alternative border"
                          v-model="item.quantity"
                          data-vv-validate-on="blur"
                          v-validate="'required|min:1'"
                          :data-vv-as="$t('quantity')"
                          name="quantity"
                          autocomplete="off"
                          @keypress="onlyNumber"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('quantity')"
                          ><small>{{ errors.first("quantity") }}</small></span
                        >
                      </div>
                      <div class="col-md-3" >
                        <b-button
                        v-if="warehouse_qty.length > 1"
                          variant="danger mt-5"
                          size="sm"
                          @click="remove(index)"
                        >
                          <i class="far fa-times-circle"></i>
                        </b-button>
                      </div>
                    </div>
                    <div class="col-md-12 mt-4">
                      <b-button
                        class="float-right"
                        variant="primary"
                        @click="add"
                        type="submit"
                        >{{ $t("save") }}</b-button
                      >
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </template>
      </card>
    </div>
    <werehouses ref="create" />
  </div>
</template>
 <script>
import { mapActions, mapGetters } from "vuex";
import Werehouses from "../Warehouses/create.vue";
export default {
  components: {
    Werehouses,
  },
  async mounted() {
    await this.getSelect(this.$route.params.company);
  },
  data() {
    return {
      id: null,
      warehouse_qty: [{ warehouse_id: null, quantity: null }],
      product_id: "",
      cont: 1,
    };
  },
  methods: {
    ...mapActions({
      getSelect: "werehouse/getWarehousesSelect",
      createInventory: "inventory/createInventary",
      addWarehouseToInventary: "inventory/addWarehouseToInventary",
    }),
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    addFind: function () {
      this.warehouse_qty.push({ warehouse_id: null, quantity: null });
    },
    remove(item) {
      this.warehouse_qty.splice(item, 1);
    },
    show(item) {
      if (item.product) {
        this.product_id = item.product;
      } else {
        this.product_id = item;
      }
      this.$bvModal.show("bv-modal-inventory");
    },
    async updateCities(id) {
      await this.getCities(id);
    },
    async add() {
      try {
        const validation = await this.$validator.validateAll();
        if (validation) {
          if (this.$route.params.type == 1) {
            const res = await this.createInventory({
              product_id: this.$route.params.id,
              warehouse_qty: this.warehouse_qty,
            });
            this.$toast.success(res.message, {
              position: "top-right",
            });
            this.$router.push({
              name: "inventory_show",
              params: { id: this.$route.params.id },
            });
          } else if (this.$route.params.type == 2) {
            const res = await this.addWarehouseToInventary({
              product_id: this.$route.params.id,
              warehouse_qty: this.warehouse_qty,
            });
            this.$toast.success(res.message, {
              position: "top-right",
            });
            this.$router.push({
              name: "inventory_show",
              params: { id: this.$route.params.id },
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapGetters({
      warehouseSelect: "werehouse/warehouseSelect",
    }),
    warehouseData() {
      return this.warehouseSelect ? this.warehouseSelect : [];
    },
    countriesOptions() {
      if (this.countries) {
        if (this.countries.data) {
          return this.countries.data.map(({ id: value, name: label }) => ({
            value,
            label,
          }));
        }
      }
      return [];
    },
    citiesOptions() {
      if (this.cities) {
        if (this.cities.data) {
          return this.cities.data.map(({ id: value, name: label }) => ({
            value,
            label,
          }));
        }
      }
      return [];
    },
  },
};
</script>
<style>
.vs__dropdown-toggle {
  border: none;
}
.vs__search {
  color: rgb(189, 189, 189);
}
.vti__input::-webkit-input-placeholder {
  color: rgb(189, 189, 189) !important;
}
</style>